// import React from "react";

// const AssignTableList = () => {
//   return <div>AssignTableList</div>;
// };

// export default AssignTableList;

import React, { useState } from "react";
import { AssignTable } from "../../../../../components";

// Utility Functions
const generateBdmList = (count = 6) => {
  return Array.from({ length: count }, (_, i) => ({
    id: i + 1,
    name: `BDM ${i + 1}`,
    email: `bdm${i + 1}@example.com`,
  }));
};

const generateTeamList = (count = 9) => {
  const designations = ["senior", "junior", "fresher"];
  return Array.from({ length: count }, (_, i) => ({
    id: i + 1,
    name: `Team ${i + 1}`,
    email: `team${i + 1}@example.com`,
    designation: designations[Math.floor(Math.random() * designations.length)],
    //emailsCount: Math.floor(Math.random() * 5) + 2, // 2–7
    //need dummy email ids 2-5
    emailsList: Array.from(
      { length: Math.floor(Math.random() * 4) + 2 },
      (_, i) => `team${i + 1}@example.com`
    ),
  }));
};

const AssignTableList = () => {
  const [assignmentOutput, setAssignmentOutput] = useState(null);

  // Sample data structure
  const sampleData = {
    bdmList: generateBdmList(7),
    teamList: generateTeamList(89),
  };

  const handleAssignmentOutput = (assignments) => {
    setAssignmentOutput(assignments);
    console.log("Assignment Output:", assignments);
  };

  return (
    <div className="w-full overflow-auto">
      <AssignTable
        data={sampleData}
        output={handleAssignmentOutput}
        //shuffleType={"range"}
      />
    </div>
  );
};

export default AssignTableList;
